/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import {
  propTypesIllustration,
  propTypesTextHtml,
} from '../../../constants/Proptypes';

const propTypesSliceGridWithGrades = {
  first_criteria: PropTypes.string,
  fourth_criteria: PropTypes.string,
  grid_with_grades_title: PropTypes.string,
  second_criteria: PropTypes.string,
  third_criteria: PropTypes.string,
};

const propTypesItemsGridWithGrades = {
  first_criteria_grade: PropTypes.string,
  second_criteria_grade: PropTypes.string,
  third_criteria_grade: PropTypes.string,
  fourth_criteria_grade: PropTypes.string,
  name_with_links: PropTypes.shape(propTypesTextHtml),
  logo: PropTypes.shape(propTypesIllustration),
  last_column_content: PropTypes.shape(propTypesTextHtml),
  first_column_content: PropTypes.shape(propTypesTextHtml),
};

export const propTypesDataGridWithGrades = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceGridWithGrades),
  items: PropTypes.arrayOf(PropTypes.shape(propTypesItemsGridWithGrades)),
};
